import { NgModule } from '@angular/core';

import { LabelService } from "./label.service";

@NgModule({
    providers: [LabelService]
})
export class LabelModule {  }